var _rect, _polygon, _g, _path, _g2, _path2, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDacHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2799.4 2104.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 875.8,
    y: 364,
    className: "st0",
    width: 78.5,
    height: 599.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "2049.5,1371.2 1747.5,868.1 1813.9,826.1 2115.4,1328.4 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1881.1,1031h-1c0.7,9.9,1,20,1,30.1V1031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.1,1089.9v-28.7c0,9.2-0.3,18.3-0.9,27.3L1881.1,1089.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.2,1211.9c-12.3,30.1-27.7,58.6-45.9,85v192.6h78.5v-225.7L1838.2,1211.9L1838.2,1211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880,1031c-26.8-455.8-665.4-569.9-849.8-155.4l51.5,86.9c74.3-301.8,510.8-363.8,665.8-94.4 c29.6,29.6,75.9,125.9,96.6,162.9L1880,1031L1880,1031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.4,1331c170.7,223.6,567.3,207.3,716-32.5v-156.2c0.5-2.8-7.8-13.5-8.8-15.9 c-45.3,281.8-467.5,389.7-637.6,166.9L1077.4,1331L1077.4,1331z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.3,1138.9v158.1c18.2-26.4,33.7-54.9,45.9-85L1792.3,1138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.2,1088.5c1.2-19,1.1-38.5-0.2-57.4h-35.9L1880.2,1088.5L1880.2,1088.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M865.3,1148.3c-95.8,412.1-726.9,341.2-723.8-87.2C135.1,689,654.5,557.6,828,880.3 c32.7,32.3,100.8,182,124.3,223.3C992,491.4,83.6,444.5,63,1061.2c-6.6,478.2,677.1,612,855,176.1L865.3,1148.3L865.3,1148.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2049.5,1371.2c160.3,203.6,553.8,166.1,687-58.4l-64.6-44.6c-110.4,175.9-412.4,224.3-556.5,60.2 L2049.5,1371.2L2049.5,1371.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2019,949.8c75.7-282.4,495.9-345.5,651.4-97.8l64.6-44.6c-172.3-275.6-636.2-240.7-765.8,56.5L2019,949.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2148.2,1371.5c-21.2-21.8-39.6-46.3-54.7-72.8l2.7-1.5c14.9,26.2,33.2,50.5,54.2,72.1L2148.2,1371.5 L2148.2,1371.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1077.4,1331 830.5,884.7 898.2,842.7 1146.9,1293.3 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDacHeader);
export default __webpack_public_path__ + "static/media/dac-header.d139bd14d629ca4050e2411f4897966f.svg";
export { ForwardRef as ReactComponent };